import React from "react";
import { Link } from "react-router-dom";
import { Lock, Shirt, Coffee, BadgeCheck, Bell } from "lucide-react";
import { PageHero } from "@/components/Bits";
import { Reveal } from "@/components/Reveal";

const ITEMS = [
  { icon: Shirt, name: "Resilience Tee", desc: "Soft organic cotton with an embossed BSN sunrise.", price: "$32" },
  { icon: Coffee, name: "Dawn Ceramic Mug", desc: "Navy & gold stoneware for your morning anchor.", price: "$24" },
  { icon: BadgeCheck, name: "Hope Enamel Pin", desc: "Gold-plated BSN seal to wear your courage.", price: "$12" },
  { icon: Shirt, name: "Comfort Hoodie", desc: "Weighted-soft hoodie with 'Still Here' embroidery.", price: "$58" },
];

export default function MerchPreview() {
  return (
    <div data-testid="merch-preview-page">
      <PageHero
        eyebrow="Patron Merch Vault · Preview"
        title="Something warm is coming soon"
        subtitle="A private preview of the upcoming Bright Stories Network merch drop. Not yet public — thank you for the early peek."
        testid="merch-hero"
      >
        <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-bsn-gold/15 text-bsn-champagne border border-bsn-gold/40 text-sm font-semibold">
          <Lock className="w-4 h-4" /> Opening Soon — Hidden Pre-Launch
        </span>
      </PageHero>

      <section className="max-w-7xl mx-auto px-4 py-16 sm:py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ITEMS.map((it, i) => (
            <Reveal key={it.name} delay={i * 80}>
              <div className="h-full bg-white rounded-2xl overflow-hidden card-tactile flex flex-col opacity-95" data-testid={`merch-item-${i}`}>
                <div className="h-44 bg-gradient-to-br from-bsn-navy to-bsn-midnight flex items-center justify-center relative">
                  <it.icon className="w-14 h-14 text-bsn-gold/70" />
                  <span className="absolute top-3 right-3 text-[10px] font-mono uppercase tracking-wider px-2 py-1 rounded-full bg-bsn-gold text-bsn-midnight">Soon</span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-serif text-lg font-semibold text-bsn-midnight">{it.name}</h3>
                  <p className="text-sm text-bsn-sapphire/75 mt-2 flex-1">{it.desc}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="font-display text-xl font-bold gold-text">{it.price}</span>
                    <button disabled className="px-4 py-2 rounded-full bg-bsn-canvas text-bsn-sapphire/60 text-sm font-semibold cursor-not-allowed">Notify Me</button>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 text-center bg-bsn-canvas rounded-2xl p-8 card-tactile">
          <Bell className="w-8 h-8 text-bsn-bronze mx-auto mb-3" />
          <p className="font-serif text-xl text-bsn-midnight">This vault is hidden from the main menu until launch.</p>
          <p className="text-sm text-bsn-sapphire/75 mt-2">In the meantime, explore our Digital Shop for printable resources available today.</p>
          <Link to="/shop" className="mt-5 inline-flex items-center gap-2 px-6 py-3 rounded-full btn-gold font-semibold transition-all" data-testid="merch-to-shop">
            Visit the Digital Shop
          </Link>
        </div>
      </section>
    </div>
  );
}
